import React from 'react';
import {
  columnCode,
  columnDescription,
  columnName,
  columnNameLink,
  columnNameReference,
  hasColumn,
} from '@/constants/fields';
import SortedColumn from './SortedColumn';
import UnsortedColumn from './UnsortedColumn';

const StaticNameDescriptionColumns = ({ columns = [] }) => (
  <>
    {hasColumn(columns, [columnName, columnNameLink]) && (<SortedColumn name={columnName} sorted asc />)}
    {hasColumn(columns, columnNameReference) && (<SortedColumn name={columnNameReference} sorted asc />)}
    {hasColumn(columns, columnCode) && (<UnsortedColumn columnId={columnCode} />)}
    {hasColumn(columns, columnDescription) && (<UnsortedColumn columnId={columnDescription} />)}
  </>
);

export default StaticNameDescriptionColumns;
